module.exports = __webpack_public_path__ + "img/settings.d8464ea0.svg";